export default __webpack_public_path__ + "static/media/paper.47425d72.svg";